import { Player, PlayerRef } from "@remotion/player";
import { MyComposition } from "./MyComposition"; // ✅ Solo el componente
import { useEffect, useRef, useState } from "react";

export const VideoPlayer = () => {
	const playerRef = useRef<PlayerRef>(null);
	const [estado, setEstado] = useState(false);
	const [count, setCount] = useState(true);

	useEffect(() => {
		setEstado(true);
		const ele = document.getElementById("butn") as HTMLInputElement;
		const doc: any = document.body;
		const docc: any = document;
		ele?.addEventListener("click", function handleClick(event) {
			console.log(count);
			if (count) {
				console.log("opn");
				doc.webkitRequestFullscreen();
				setCount(false);
			} else {
				console.log("cls");
				docc.webkitExitFullscreen();
				setCount(true);
			}
		});
		//}
	}, [count]);
	return (
		<div>
			<div
				className="overlayplay"
				onClickCapture={(e) => {
					const { current } = playerRef;
					if (current?.isPlaying()) {
						current.pause();
					} else {
						current?.play();
					}
				}}
				style={{
					position: "absolute",
					width: "100%",
					height: "90vh",
					zIndex: 1,
					display: "none",
				}}
			></div>
			<Player
				controls
				component={MyComposition}
				durationInFrames={2540}
				compositionWidth={1920}
				compositionHeight={1080}
				fps={30}
				ref={playerRef}
				style={{ width: "100%", height: "100vh" }}
				acknowledgeRemotionLicense={true}
			/>
			<div
				className="fulls"
				style={{
					position: "absolute",
					right: "12px",
					bottom: "37px",
					display: estado ? "block" : "none",
				}}
			>
				<button
					type="button"
					id="butn"
					aria-label="Enter Fullscreen"
					title="Enter Fullscreen"
					style={{
						appearance: "none",
						backgroundColor: "transparent",
						border: "none",
						cursor: "pointer",
						padding: "0px",
						display: "inline",
						marginBottom: "0px",
						marginTop: "0px",
						height: "25px",
					}}
				>
					<svg viewBox="0 0 32 32" height="16" width="16">
						<path
							d="
          M 3 12
          L 3 3
          L 12 3
          "
							style={{
								stroke: "#fff",
								strokeWidth: "6",
								fill: "none",
							}}
						></path>
						<path
							d="
          M 29 12
          L 29 3
          L 20 3
          "
							style={{
								stroke: "#fff",
								strokeWidth: "6",
								fill: "none",
							}}
						></path>
						<path
							d="
          M 3 20
          L 3 29
          L 12 29
          "
							style={{
								stroke: "#fff",
								strokeWidth: "6",
								fill: "none",
							}}
						></path>
						<path
							d="
          M 29 20
          L 29 29
          L 20 29
          "
							style={{
								stroke: "#fff",
								strokeWidth: "6",
								fill: "none",
							}}
						></path>
					</svg>
				</button>
			</div>
		</div>
	);
};
